import './timer.scss';

export default {
  timer: 'ssg-timer',
  remainingTimeWrapperActive: 'timer-remaining-background active',
  remainingTimeWrapper: 'timer-remaining-background',
  remainingTimeActive: 'timer-countdown active',
  remainingTime: 'timer-countdown',
}



// WEBPACK FOOTER //
// src/common/timer-component/timer.style.js